import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';
import { REDCRSS_EVENTS } from '../../../../../../shared/services/constants/redcross_evemts';

@Component({
  selector: 'yi-install-reviews-widget',
  template: require('./install_reviews_widget.component.html'),
  styles: [require('./install_reviews_widget.component.scss')]

})

export class InstallReviewsWidgetComponent extends AccordionContentComponent {

  navigateToProductLiquid() {
    this.redcrossService.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'URL',
      ctaLocation: this.translatedTitle(this.item),
      ctaURL: this.item.getData().themes
    });
    this.redirectService.redirectTo(this.item.getData().themes, true);
  }
}
